import { I18n } from '@calendly/i18n';
import { CheckboxInput } from '@calendly/ui/components/checkbox-input';
import { Link } from '@calendly/ui/components/link';
import { ProTip } from '@calendly/ui/components/pro-tip';
import { BodyText } from '@calendly/ui/components/typography';
import { textColorSecondary4 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { CheckboxLeftColumnWrapper, CheckboxRightColumnWrapper, LabelContainer, StyledLabel } from './styles';
const checkboxLabelCss = "c1b06p4m";
const CheckboxLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(checkboxLabelCss, props.className)} />;
});
export const BufferViewCheckbox = ({
  showBuffers,
  toggleShowBuffers
}) => <>
    <CheckboxLeftColumnWrapper>
      <LabelContainer>
        <StyledLabel id="buffers_checkbox_label">
          <BodyText weight="bold">
            {I18n.t('publisher.meetings.filter_modal.buffers.label')}
          </BodyText>
        </StyledLabel>
        <ProTip>
          {I18n.t('publisher.scheduled_events.buffers.pro_tip_text')}
          {' '}
          <Link rel="noopener noreferrer" target="_blank" underline={false} href="https://calendly.com/help/how-to-use-buffers">
            <BodyText inline weight="bold" color={textColorSecondary4}>{I18n.t('publisher.action.learn_more')}</BodyText>
          </Link>
        </ProTip>
      </LabelContainer>
    </CheckboxLeftColumnWrapper>
    <CheckboxRightColumnWrapper fieldColumn>
      <CheckboxLabel>
        <CheckboxInput aria-labelledby="buffers_checkbox_label" checked={showBuffers} onChange={e => toggleShowBuffers(e.target.checked)} />
        <BodyText>{I18n.t('publisher.meetings.filter_modal.buffers.show_buffers')}</BodyText>
      </CheckboxLabel>
    </CheckboxRightColumnWrapper>
  </>;

require("./buffer_view_checkbox.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./buffer_view_checkbox.js");